import React from 'react';
import Overview from './components/MainPage';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AboutUs from "./components/AboutUs";   // Your About Us page
import SocialSidebar from "./components/SocialSidebar";  // ✅ import the sidebar

function App() {
   return (
    <Router>
            <SocialSidebar /> {/* ✅ show icons on all pages */}

      <Routes>
        <Route path="/" element={<Overview />} />
        <Route path="/about-us" element={<AboutUs />} />
      </Routes>
    </Router>
  );
}

export default App;


